// StartWorkButton.tsx
import React, { useState } from "react";
import { UniButton } from "../../../../../../@WUM/core/Elements";
import { clockTimingInterface } from "../../../../API/request/clockTimingInterface";
import {StartBreak, StopWork} from "../../../../API/response/worktimeclock";

interface StartBreakButtonProps {
    onSuccess?: (result: clockTimingInterface) => void;
}

const StartBreakButton = ({ onSuccess }: StartBreakButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleStart = async () => {
        setLoading(true);
        const result = await StartBreak();
        await StopWork();
        setLoading(false);

        if (result) {
            localStorage.setItem("startBreak", new Date().toISOString());
            onSuccess?.(result); // 🔁 Übergabe an Parent
        }
    };

    return (
        <UniButton disabled={loading} onClick={handleStart} class={""} variant={"warning"}>
            {loading ? "..." : "🏖️ Pause beginnen"}
        </UniButton>
    );
};

export default StartBreakButton;
